import { HttpClient } from '@angular/common/http'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { BypassSecurityTrustUrlPipe } from 'app/shared/bypass-security-trust-url.pipe'
import { TranslatePipe } from 'app/shared/translate.pipe'

import { LazyVideoComponent } from '../base/lazy-video.component'

function createIframeUrl(videoId: string): string {
  const params = new URLSearchParams({
    autoplay: '1',
  })
  return `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?${params.toString()}`
}

@Component({
  selector: 'pai-lazy-vimeo',
  imports: [BypassSecurityTrustUrlPipe, TranslatePipe],
  templateUrl: '../base/lazy-video.component.html',
  styleUrls: ['../base/lazy-video.component.scss', './lazy-vimeo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyVimeoComponent extends LazyVideoComponent implements OnInit {
  get placeholderImageSrcUrl(): string {
    // todo: we should use picture element with srcset
    return this._placeholderImage ?? ''
  }

  get videoType(): string {
    return 'vimeo'
  }

  private readonly httpClient = inject(HttpClient)
  private readonly cd = inject(ChangeDetectorRef)
  private _placeholderImage: string | null = null

  ngOnInit() {
    if (this.videoId) {
      void this.loadPlaceholderUrl()
    }
  }

  protected warmup(): void {
    this.preconnectLinkService.add(
      'https://player.vimeo.com',
      'https://i.vimeocdn.com',
      'https://f.vimeocdn.com',
      'https://fresnel.vimeocdn.com',
    )
  }

  protected initIframe(iframeEl: HTMLIFrameElement) {
    iframeEl.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
    iframeEl.allowFullscreen = true
    iframeEl.src = createIframeUrl(this.videoId)
  }

  private async loadPlaceholderUrl() {
    const apiUrl = `https://vimeo.com/api/v2/video/${this.videoId}.json`
    const json: any = await firstValueFrom(this.httpClient.get(apiUrl))
    this._placeholderImage = json[0].thumbnail_large
    this.cd.detectChanges()
  }
}
